{
  "title": "Infestation",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "Conjuration cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (a living flea)",
  "duration": "Instantaneous",
  "description": [
    "You cause a cloud of mites, fleas, and other parasites to appear momentarily on one creature you can see within range. The target must succeed on a Constitution saving throw, or it takes 1d6 poison damage and moves 5 feet in a random direction if it can move and its speed is at least 5 feet. Roll a d4 for the direction: 1, north; 2, south; 3, east; or 4, west. This movement doesn’t provoke opportunity attacks, and if the direction rolled is blocked, the target doesn't move.",
    "At Higher Levels. The spell’s damage increases by 1d6 when you reach 5th level (2d6), 11th level (3d6), and 17th level (4d6)."
  ],
  "spellLists": ["druid", "eldritch-knight", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
